


















































import TradingBlockRemote, {GetRefClientId, Filter, padStart} from "../../services/TradingBlockRemote";
import Component from 'vue-class-component'
import {Prop, Watch, Vue, Emit, Inject} from 'vue-property-decorator'
import {OrderStatusMap} from "../../domain/TbMaps";
import {Messages, OrderMessages} from "../../services/EventBus";
import {addDays} from "../../utils/vue_utils";
import {OrderDuration, OrderStatus} from "../../domain/types";

import {Datepicker, Dropdown,DurationRadioGroup} from '../Common'

@Component({
    components: {Datepicker,Dropdown,DurationRadioGroup }
})
export default class OrderSearch extends Vue {
    Periods= { 0:'Today',7:'Last 7 Days',30:'Last 30 Days',60:'Last 60 Days',90:'Last 90 Days'};
    Period: number=0;
    Symbol: string="";
    //From: string="";
    //To:string="";
    ToDateError: string="";
    FromDateError: string ="" ;
    OrderStatusId: number=-1;
    utcOffset: string="";
    AssetType:number=0;
    Duration: OrderDuration=OrderDuration.Unknown;
    IsWorkingOrderFilter:boolean= false;
    StatusMap: any = OrderStatusMap as any;
    filter: Filter={
        pageIndex : 1,
        pageSize: 100,
        //ExcludeDurationId: 4
    } as Filter;

    public from:string="";
    get From(){
        return this.from;
    }
    set From(val:string){
        if (this.Period!=-1){
            this.Period=-1;
        }
        this.from= val;
    }
    public to:string="";
    get To(){
        return this.to;
    }
    set To(val:string){
        if (this.Period!=-1){
            this.Period=-1;
        }
        this.to = val;
    }
    advanced: boolean = false;
    toggleAdvanced(){
        if (this.advanced){
            this.Duration = OrderDuration.Unknown;
            this.OrderStatusId = OrderStatus.Undefined;
            this.AssetType = 0;
            this.advanced = false;
        } else
            this.advanced = true;

        this.setAdvanced(this.advanced);

    }

    @Emit('advanced')
    setAdvanced(v:boolean){

    }

    get ChevronClass(){
        return this.advanced?'glyphicon glyphicon-chevron-up':'glyphicon glyphicon-chevron-down';
    }


    change(val:number){
        this.Period = val;
        if (this.Period>=0 ) {

            let orig = new Date();
            let targetOffset = 5*60*60*1000;
            //let localOffset = (new Date()).getTimezoneOffset()*60*1000;

            orig.setTime(orig.getTime()- targetOffset);

            this.from = addDays(orig, -this.Period).toISOString().split('T')[0];
            this.to = (orig).toISOString().split('T')[0];
        }
    }

    sft_ui: boolean = false;
    created(){
        if(process.env.VUE_APP_SFT_ACCESS) this.sft_ui= true;
    }
    mounted(){
        // var dat = (new Date()).toISOString().split('T')[0];
        // this.From = dat;
        // this.To = dat;

        //if ( $('#OrderSearchBox_PeriodFrom').type != 'date' && $('#OrderSearchBox_PeriodFrom').datepicker) $('#OrderSearchBox_PeriodFrom').datepicker({ dateFormat: 'dd-mm-yy' });
        //if ( $('#OrderSearchBox_PeriodTo').type != 'date' && $('#OrderSearchBox_PeriodTo').datepicker) $('#OrderSearchBox_PeriodTo').datepicker({ dateFormat: 'dd-mm-yy' });
        var minutes = new Date().getTimezoneOffset()*10/6;
        var minus = minutes<0;

        this.utcOffset ="+"+(minus?"+":"-")+  padStart((Math.abs(minutes)).toString(),4,"0");
        this.change(this.Period);
    }

    searchBtnClick(){
        this.filter= {
            //IsWorkingOrderFilter: false,
            //pageIndex: 1,
            //PageSize: 50,
            //,

        }as any;




        if (this.Symbol && this.Symbol.length>0) this.filter.symbol = this.Symbol;
        if (this.From) this.filter.dateFrom = this.From;//;"/Date("+Date.parse(this.From )+this.utcOffset+")/";;
        if (this.To) this.filter.dateTo = this.To;//"/Date("+Date.parse(this.To )+this.utcOffset+")/";

        if (this.Period)
        if (this.OrderStatusId>0) this.filter.orderStatusId = this.OrderStatusId; else delete this.filter.orderStatusId;
        if (this.AssetType) this.filter.SecurityTypeId=this.AssetType;
        if (this.Duration!=OrderDuration.Unknown) this.filter.durationId = this.Duration; else delete this.filter.durationId;
        if (this.IsWorkingOrderFilter) this.filter.WorkingOrdersOnly= true; else delete this.filter.WorkingOrdersOnly;
        this.filter.pageIndex = 0 ;
        this.filter.pageSize = 50;
        this.search(this.filter);
    }

    resetBtnClick(){
        this.reset();
    }

    @Emit(OrderMessages.OrdersSearch as string)
    search(filter:Filter){

    }

    reset(){
        this.Period=-1;
        this.Symbol ="";
        this.From="";
        this.To="";
        this.ToDateError="";
        this.FromDateError ="" ;
        this.OrderStatusId = -1;
        this.filter= {
            pageIndex: 1,
            pageSize: 100,
        } as Filter;
    }
}
